import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
const CrossFadeBase = styled('div')({
    transition: 'opacity 0.5s, visibility 0.5s',
    width: '100%'
});
const PreviousContent = styled(CrossFadeBase)({
    opacity: 0,
    height: 0,
    overflowY: 'visible',
    visibility: 'hidden'
});
const ActiveContent = styled(CrossFadeBase)({
    opacity: 1
});
const UpcomingContent = styled(CrossFadeBase)({
    opacity: 0
});
export const CrossFade = (props) => {
    const { children } = props;
    const contentQueue = useRef([null]);
    const contentKeys = useRef([1]);
    contentQueue.current = [children, contentQueue.current[0]];
    contentKeys.current = [contentKeys.current[0] + 1, contentKeys.current[0]];
    return (React.createElement(React.Fragment, null,
        React.createElement(PreviousContent, { key: contentKeys.current[1] }, contentQueue.current[1]),
        React.createElement(ActiveContent, { key: contentKeys.current[0] }, contentQueue.current[0]),
        React.createElement(UpcomingContent, { key: contentKeys.current[0] + 1 }, null)));
};
//# sourceMappingURL=CrossFade.js.map